import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SalesPage } from "./components/SalesPage";
import { SuccessPage } from "./components/SuccessPage";
import { AdminDashboard } from "./pages/AdminDashboard";
import { SetterPage } from "./pages/SetterPage";
import { MentionsLegales, PolitiqueConfidentialite, CGV } from "./pages/LegalPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SalesPage />} />
          <Route path="/reserver" element={<SalesPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/setters" element={<SetterPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
